/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_2_VInputs */

const en_mk_aicost_2_v = /** @type {(inputs: Mk_Aicost_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 15 – 50`)
};

const id_mk_aicost_2_v = /** @type {(inputs: Mk_Aicost_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 15 – 50`)
};

/**
* | output |
* | --- |
* | "Rp 15 – 50" |
*
* @param {Mk_Aicost_2_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_2_v = /** @type {((inputs?: Mk_Aicost_2_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_2_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_2_v(inputs)
	return en_mk_aicost_2_v(inputs)
});